import { render, staticRenderFns } from "./FireClaimUpdateStatus.vue?vue&type=template&id=5bca322d&"
import script from "./FireClaimUpdateStatus.vue?vue&type=script&lang=js&"
export * from "./FireClaimUpdateStatus.vue?vue&type=script&lang=js&"
import style0 from "./FireClaimUpdateStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FireClaimUpdateStatus.vue"
export default component.exports